/* =========================================================
   DISTRIBUIDORA — FRETE NO CART DRAWER (LOGICA)
   Arquivo: assets/distribuidora-frete-drawer.js
   ========================================================= */

(function () {
  const STORAGE_KEY = 'dfc_zip';

  const DELIVERY_ZONES = Array.isArray(window.dfcDeliveryZones)
    ? window.dfcDeliveryZones
    : [];

  function onlyDigits(v) {
    return (v || '').replace(/\D/g, '');
  }

  function formatCep(d) {
    d = onlyDigits(d).slice(0, 8);
    return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
  }

  function moneyFromCents(cents) {
    return (cents / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function findDeliveryZone(zip8) {
    if (!zip8 || zip8.length !== 8) return null;

    return DELIVERY_ZONES.find((zone) =>
      Array.isArray(zone.zipRanges) &&
      zone.zipRanges.some(([start, end]) => zip8 >= start && zip8 <= end)
    ) || null;
  }

  function setStatus(root, text) {
    const el = root.querySelector('[data-dfc-status]');
    if (el) el.textContent = text;
  }

  function setResults(root, html) {
    const el = root.querySelector('[data-dfc-results]');
    if (el) el.innerHTML = html || '';
  }

  function setBtnLoading(root, loading) {
    const btn = root.querySelector('[data-dfc-btn]');
    if (!btn) return;
    btn.disabled = !!loading;
    btn.textContent = loading ? 'Calculando...' : 'Calcular';
  }

  function getCartTotalCentsFromDOM() {
    const el = document.querySelector('#CartDrawer .totals__total-value');
    if (!el) return null;

    const txt = (el.textContent || '').trim();
    const cleaned = txt
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    const value = Number(cleaned);
    if (!Number.isFinite(value)) return null;

    return Math.round(value * 100);
  }

  function getOriginalTotalEl() {
    return document.querySelector('#CartDrawer .totals__total-value');
  }

  function getOriginalSubtotalCents() {
    const el = getOriginalTotalEl();
    if (!el) return null;

    if (!el.dataset.originalTotal) {
      el.dataset.originalTotal = el.textContent.trim();
    }

    const txt = el.dataset.originalTotal;
    const cleaned = txt
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    const value = Number(cleaned);
    if (!Number.isFinite(value)) return null;

    return Math.round(value * 100);
  }

  function updateDisplayedEstimatedTotal(totalCents) {
    const el = getOriginalTotalEl();
    if (!el) return;

    el.textContent = `${moneyFromCents(totalCents)} BRL`;
  }

  function resetDisplayedEstimatedTotal() {
    const el = getOriginalTotalEl();
    if (!el) return;

    if (el.dataset.originalTotal) {
      el.textContent = el.dataset.originalTotal;
    }
  }

  function getLowestRateCents(rates) {
    if (!Array.isArray(rates) || !rates.length) return null;

    const values = rates
      .map((r) => {
        if (typeof r.price === 'string') {
          const v = Number(String(r.price).replace(',', '.'));
          return Number.isFinite(v) ? Math.round(v * 100) : null;
        }

        if (typeof r.price === 'number') {
          return r.price;
        }

        return null;
      })
      .filter((v) => Number.isFinite(v) && v > 0);

    if (!values.length) return null;
    return Math.min(...values);
  }

  function showError(root, msg) {
    resetDisplayedEstimatedTotal();

    setStatus(root, 'Erro ao calcular');
    setResults(root, `
      <div class="dfc-results">
        <div class="dfc-line">
          <span class="dfc-pill dfc-warn">Falhou</span>
          <small>${msg}</small>
        </div>
      </div>
    `);
  }

  function getCarrierLogo(name) {
    const n = String(name || '').toLowerCase().trim();
    const A = window.dfcAssets || {};

    if (n.includes('jadlog')) return A.jadlog || '';

    if (n.includes('braspress')) return A.braspress || '';

    if (
      n.includes('j&t') ||
      n.includes('j&t express') ||
      n.includes('j&t standard') ||
      n.includes('jtexpress') ||
      n === 'jt'
    ) {
      return A.jt || '';
    }

    if (
      n.includes('sedex') ||
      n === 'pac' ||
      n.startsWith('pac ') ||
      n.endsWith(' pac') ||
      n.includes(' correios') ||
      n.startsWith('correios')
    ) {
      return A.correios || '';
    }

    return '';
  }

  function priceToBRL(rate) {
    if (typeof rate.price === 'string') {
      const v = Number(String(rate.price).replace(',', '.'));
      const cents = Number.isFinite(v) ? Math.round(v * 100) : null;
      return cents != null ? moneyFromCents(cents) : String(rate.price);
    }

    if (typeof rate.price === 'number') {
      return moneyFromCents(rate.price);
    }

    return String(rate.price ?? '');
  }

  function formatTransitDays(rate) {
    if (Array.isArray(rate.delivery_days)) {
      const min = rate.delivery_days[0];
      const max = rate.delivery_days[1];

      if (min === max) return `${min} dia${min > 1 ? 's' : ''} úteis`;
      return `${min}-${max} dias úteis`;
    }

    if (typeof rate.delivery_days === 'number') {
      const d = rate.delivery_days;
      return `${d} dia${d > 1 ? 's' : ''} úteis`;
    }

    return '';
  }

  async function fetchRates(zip8) {
  const prepareRes = await fetch('/cart/prepare_shipping_rates.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      shipping_address: {
        zip: zip8,
        province: 'SP',
        country: 'Brazil',
        country_code: 'BR'
      }
    })
  });

  if (!prepareRes.ok && prepareRes.status !== 202) {
    const t = await prepareRes.text().catch(() => '');
    throw new Error(`prepare erro: ${t || prepareRes.status}`);
  }

  for (let i = 0; i < 35; i++) {
    await new Promise((r) => setTimeout(r, 800));

    const res = await fetch('/cart/async_shipping_rates.json', {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    });

    if (res.status === 202) {
      continue;
    }

    if (!res.ok) {
      const t = await res.text().catch(() => '');
      throw new Error(`async erro: ${t || res.status}`);
    }

    let data = null;
    try {
      data = await res.json();
    } catch (e) {
      data = null;
    }

    if (data && Array.isArray(data.shipping_rates)) {
      return data.shipping_rates;
    }
  }

  return [];
}

 function filterRatesForDisplay(rates, zone, meetsMin) {
  if (!Array.isArray(rates)) return [];

  return rates.filter((r) => {
    const name = String(r?.name || '').toLowerCase().trim();

    // remove sempre Local Delivery
    if (
      name.includes('local delivery') ||
      name.includes('entrega local')
    ) {
      return false;
    }

    return true;
  });
}
  function renderOwnDelivery(root, zone, meetsMin) {
    const subtotalCents = getOriginalSubtotalCents();
    const freeIcon = (window.dfcAssets && window.dfcAssets.freteGratis) || '';

    setStatus(root, meetsMin ? 'Frete grátis' : zone.name);

    if (!meetsMin) {
      resetDisplayedEstimatedTotal();

      setResults(root, `
        <div class="dfc-results">
          <div class="dfc-rate dfc-rate--free">
            <div class="dfc-rate__left">
              <div class="dfc-rate__logo">
                ${
                  freeIcon
                    ? `<img src="${freeIcon}" alt="Frete grátis" loading="lazy">`
                    : `<div class="dfc-rate__logo-fallback"></div>`
                }
              </div>

              <div class="dfc-rate__meta">
                <div class="dfc-rate__name">${zone.name}</div>
                <div class="dfc-rate__pill">${zone.unavailableText}</div>
              </div>
            </div>
          </div>
        </div>
      `);
      return;
    }

    if (subtotalCents != null) {
      updateDisplayedEstimatedTotal(subtotalCents + zone.priceCents);
    }

    setResults(root, `
      <div class="dfc-results">
        <div class="dfc-rate dfc-rate--free">
          <div class="dfc-rate__left">
            <div class="dfc-rate__logo">
              ${
                freeIcon
                  ? `<img src="${freeIcon}" alt="Frete grátis" loading="lazy">`
                  : `<div class="dfc-rate__logo-fallback"></div>`
              }
            </div>

            <div class="dfc-rate__meta">
              <div class="dfc-rate__name">Frete grátis</div>
              <div class="dfc-rate__pill">${zone.eligibleText}</div>
            </div>
          </div>

          <div class="dfc-rate__price">
            ${zone.priceCents === 0 ? 'GRÁTIS' : moneyFromCents(zone.priceCents)}
          </div>
        </div>
      </div>
    `);
  }

  function renderOwnDeliveryWithRates(root, zone, meetsMin, rates) {
    const freeIcon = (window.dfcAssets && window.dfcAssets.freteGratis) || '';
    const visibleRates = filterRatesForDisplay(rates, zone, meetsMin);

    let freeCard = '';

    if (meetsMin) {
      const subtotalCents = getOriginalSubtotalCents();
      if (subtotalCents != null) {
        updateDisplayedEstimatedTotal(subtotalCents + zone.priceCents);
      }

      freeCard = `
        <div class="dfc-rate dfc-rate--free">
          <div class="dfc-rate__left">
            <div class="dfc-rate__logo">
              ${
                freeIcon
                  ? `<img src="${freeIcon}" alt="Frete grátis" loading="lazy">`
                  : `<div class="dfc-rate__logo-fallback"></div>`
              }
            </div>

            <div class="dfc-rate__meta">
              <div class="dfc-rate__name">Frete grátis</div>
              <div class="dfc-rate__pill">${zone.eligibleText}</div>
            </div>
          </div>

          <div class="dfc-rate__price">
            ${zone.priceCents === 0 ? 'GRÁTIS' : moneyFromCents(zone.priceCents)}
          </div>
        </div>
      `;
    } else {
      freeCard = `
        <div class="dfc-rate dfc-rate--free">
          <div class="dfc-rate__left">
            <div class="dfc-rate__logo">
              ${
                freeIcon
                  ? `<img src="${freeIcon}" alt="Frete grátis" loading="lazy">`
                  : `<div class="dfc-rate__logo-fallback"></div>`
              }
            </div>

            <div class="dfc-rate__meta">
              <div class="dfc-rate__name">${zone.name}</div>
              <div class="dfc-rate__pill">${zone.unavailableText}</div>
            </div>
          </div>
        </div>
      `;
    }

    let frenetCards = '';
    const totalHint = 'Valores estimados (podem variar no checkout).';

    if (visibleRates && visibleRates.length) {
      const cards = visibleRates.slice(0, 8).map((r) => {
        const name = r.name || 'Frete';
        const logo = getCarrierLogo(name);
        const priceTxt = priceToBRL(r);
        const daysTxt = formatTransitDays(r);

        return `
          <div class="dfc-rate">
            <div class="dfc-rate__left">
              <div class="dfc-rate__logo">
                ${
                  logo
                    ? `<img src="${logo}" alt="${name}" loading="lazy">`
                    : `<div class="dfc-rate__logo-fallback"></div>`
                }
              </div>

              <div class="dfc-rate__meta">
                <div class="dfc-rate__name">${name}</div>
                ${daysTxt ? `<div class="dfc-rate__pill">${daysTxt}</div>` : ``}
              </div>
            </div>

            <div class="dfc-rate__price">${priceTxt}</div>
          </div>
        `;
      }).join('');

      frenetCards = `
        <div class="dfc-results__label">Outras opções de envio:</div>
        <div class="dfc-rates">
          ${cards}
        </div>
      `;

      if (!meetsMin) {
        const subtotalCents = getOriginalSubtotalCents();
        const lowestRateCents = getLowestRateCents(visibleRates);

        if (subtotalCents != null && lowestRateCents != null) {
          updateDisplayedEstimatedTotal(subtotalCents + lowestRateCents);
        }
      }
    }

    setStatus(root, meetsMin ? 'Frete grátis + Transportadoras' : zone.name);
    setResults(root, `
      <div class="dfc-results">
        <div class="dfc-rates">
          ${freeCard}
        </div>
        ${frenetCards}
        <div class="dfc-results__hint">${totalHint}</div>
      </div>
    `);
  }

  function renderFrenetPlaceholder(root) {
  resetDisplayedEstimatedTotal();

  setStatus(root, 'Transportadora / Correios');
  setResults(root, `
    <div class="dfc-results">
      <div class="dfc-line">
        <span class="dfc-pill dfc-warn">Frete calculado via Frenet</span>
        <small>Não foi possível listar as opções no carrinho. Confira no checkout.</small>
      </div>
    </div>
  `);
}

  function renderRates(root, rates) {
    if (!rates || rates.length === 0) {
      resetDisplayedEstimatedTotal();
      renderFrenetPlaceholder(root);
      return;
    }

    const cards = rates.slice(0, 8).map((r) => {
      const name = r.name || 'Frete';
      const logo = getCarrierLogo(name);
      const priceTxt = priceToBRL(r);
      const daysTxt = formatTransitDays(r);

      return `
        <div class="dfc-rate">
          <div class="dfc-rate__left">
            <div class="dfc-rate__logo">
              ${
                logo
                  ? `<img src="${logo}" alt="${name}" loading="lazy">`
                  : `<div class="dfc-rate__logo-fallback"></div>`
              }
            </div>

            <div class="dfc-rate__meta">
              <div class="dfc-rate__name">${name}</div>
              ${daysTxt ? `<div class="dfc-rate__pill">${daysTxt}</div>` : ``}
            </div>
          </div>

          <div class="dfc-rate__price">${priceTxt}</div>
        </div>
      `;
    }).join('');

    const subtotalCents = getOriginalSubtotalCents();
    const lowestRateCents = getLowestRateCents(rates);

    if (subtotalCents != null && lowestRateCents != null) {
      updateDisplayedEstimatedTotal(subtotalCents + lowestRateCents);
    } else {
      resetDisplayedEstimatedTotal();
    }

    setStatus(root, 'Transportadora / Correios');
    setResults(root, `
      <div class="dfc-results">
        <div class="dfc-results__label">Opções disponíveis:</div>
        <div class="dfc-rates">
          ${cards}
        </div>
        <div class="dfc-results__hint">Total estimado considera o menor frete disponível.</div>
      </div>
    `);
  }

  async function calculate(root) {
    const input = root.querySelector('[data-dfc-zip]');
    if (!input) return;

    const zip8 = onlyDigits(input.value).slice(0, 8);

    if (zip8.length !== 8) {
      setStatus(root, 'Digite um CEP válido');
      setResults(root, '');
      return;
    }

    localStorage.setItem(STORAGE_KEY, zip8);
    input.value = formatCep(zip8);

    const cartCents = getCartTotalCentsFromDOM();
    const zone = findDeliveryZone(zip8);
    const meetsMin = zone ? (cartCents == null ? true : cartCents >= zone.minOrderCents) : false;

    setBtnLoading(root, true);
    setStatus(root, zone ? zone.name : 'Calculando...');
    setResults(root, '');

    try {
      const rates = await fetchRates(zip8);

      if (zone) {
        renderOwnDeliveryWithRates(root, zone, meetsMin, rates);
      } else {
        renderRates(root, rates);
      }
    } catch (e) {
      if (zone) {
        renderOwnDelivery(root, zone, meetsMin);
      } else {
        showError(root, String(e?.message || e));
      }
    } finally {
      setBtnLoading(root, false);
    }
  }

  function bind(root) {
    if (root.__dfcBound) return;
    root.__dfcBound = true;

    const input = root.querySelector('[data-dfc-zip]');
    const btn = root.querySelector('[data-dfc-btn]');

    if (input) {
      input.addEventListener('input', () => {
        input.value = formatCep(input.value);
      });

      input.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter') {
          ev.preventDefault();
          calculate(root);
        }
      });
    }

    if (btn) {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        calculate(root);
      });
    }

    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && onlyDigits(saved).length === 8 && input) {
      input.value = formatCep(saved);
      calculate(root);
    } else {
      setStatus(root, 'Calcular frete');
    }
  }

  function init() {
    const root = document.querySelector('[data-dfc-root]');
    if (root) bind(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();

    const target = document.querySelector('#CartDrawer') || document.documentElement;
    const obs = new MutationObserver(() => init());
    obs.observe(target, { childList: true, subtree: true });
  });
})();